export enum StorageKey {

    CCMetaData = "__ccmd",
    CCPaymentDetails = "__ccpd",
    CCClientDetails = "__cccd",
    APMTransRefNum = "__aspmtrn"
}
